<template>
  <div class="chi-announcements" v-if="announcements.length">
    <h2 class="with-cropped-hr centered">Announcements</h2>
    <div v-for="announcement of announcements" :key="announcement.date" class="chi-announcement">
      <h3 v-if="announcement.title || announcement.date" :style="announcement.important ? {color: '#ea5e4a !important'} : {}">
        {{announcement.title}}
        <span class="chi-pub-date" v-if="announcement.date">
          {{(new Date(announcement.date)).toLocaleDateString()}}
        </span>
      </h3>
      <p v-html="announcement.content" v-if="announcement.content"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Announcements',
  computed: {
    announcements: function () {
      return this.raw_announcements.filter(function (item) {
        var now = Date.now();
        return !(item.start > now || item.end < now);
      });
    }
  },
  data: function () {
    return {
      raw_announcements: [/* {
        start: new Date('03/02/2022 23:59:59'),
        end: new Date('03/02/2022 23:59:59'),
        title: '',
        date: '3/2/2022',
        content: ''
      } */],
    };
  }
};
</script>
